import { CountryAlpha3Code } from './countries';

export const EXCHANGES = {
  [CountryAlpha3Code.AUS]: CountryAlpha3Code.AUS,
  [CountryAlpha3Code.BEL]: CountryAlpha3Code.BEL,
  [CountryAlpha3Code.CAN]: CountryAlpha3Code.CAN,
  [CountryAlpha3Code.CHE]: CountryAlpha3Code.CHE,
  [CountryAlpha3Code.DEU]: CountryAlpha3Code.DEU,
  [CountryAlpha3Code.DNK]: CountryAlpha3Code.DNK,
  [CountryAlpha3Code.ESP]: CountryAlpha3Code.ESP,
  [CountryAlpha3Code.FRA]: CountryAlpha3Code.FRA,
  [CountryAlpha3Code.GBR]: CountryAlpha3Code.GBR,
  [CountryAlpha3Code.HKG]: CountryAlpha3Code.HKG,
  [CountryAlpha3Code.JPN]: CountryAlpha3Code.JPN,
  [CountryAlpha3Code.NLD]: CountryAlpha3Code.NLD,
  [CountryAlpha3Code.NZL]: CountryAlpha3Code.NZL,
  [CountryAlpha3Code.SGP]: CountryAlpha3Code.SGP,
  [CountryAlpha3Code.SWE]: CountryAlpha3Code.SWE,
  [CountryAlpha3Code.USA]: CountryAlpha3Code.USA
} as const;

export type Exchange = (typeof EXCHANGES)[keyof typeof EXCHANGES];

// TODO: Replace when index is already returned or mapping is available
// https://cmcmarkets.atlassian.net/browse/SBCI-341
export const EXCHANGE_INDICES: Partial<Record<Exchange, string>> = {
  [CountryAlpha3Code.AUS]: 'SandPAsx200'
};

export const EXCHANGE_INSTRUMENTS: Partial<Record<Exchange, string>> = {
  [CountryAlpha3Code.AUS]: 'XJO'
};
